module.exports = __webpack_public_path__ + "img/howitworks-img4.2a407bc9.png";